export default __webpack_public_path__ + "static/floating-light-47aec57a38d102edab3199fe5b9ba55d.png";